"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingMoreIndicator = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function LoadingMoreIndicator(_a) {
    var style = _a.style;
    return (react_1.default.createElement(core_ui_1.Box, { backgroundColor: core_ui_1.colors.steel[50] },
        react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "center", alignItems: "center", style: style },
            react_1.default.createElement(core_ui_1.CircleSpinnerInline, null))));
}
exports.LoadingMoreIndicator = LoadingMoreIndicator;
